// extracted by mini-css-extract-plugin
export default {"editMenu":"EditMenu_editMenu__FQail","listItem":"EditMenu_listItem__ZNMTW","link":"EditMenu_link__z1xID"};